"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
const ModalCreate_vue_1 = __importDefault(require("@/components/ModalCreate.vue"));
const vue_basic_ui_1 = require("@xenodrive/vue-basic-ui");
exports.default = (0, vue_1.defineComponent)({
    __name: 'BssMovementConfig',
    setup(__props) {
        const permissions = (0, vue_3.inject)('permissions');
        const showMovementConfig = (0, vue_3.computed)(() => {
            if (!permissions['movement.config'])
                return false;
            const search = new URLSearchParams(location.search);
            if (search.get('section_id')) {
                return true;
            }
            return false;
        });
        const query = (0, vue_3.computed)(() => {
            const search = new URLSearchParams(location.search);
            return '?' + search.toString();
        });
        return (_ctx, _cache) => {
            return (showMovementConfig.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ModalCreate_vue_1.default, {
                    key: 0,
                    url: "/movement/config",
                    query: query.value,
                    action: "/movement/config/save",
                    "form-id": "movement_config-modal"
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Button), {
                            icon: "fa:cog",
                            "icon-position": "top"
                        }, {
                            default: (0, vue_2.withCtx)(() => _cache[0] || (_cache[0] = [
                                (0, vue_2.createTextVNode)("動態設定", -1)
                            ])),
                            _: 1,
                            __: [0]
                        })
                    ]),
                    _: 1
                }, 8, ["query"]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
